import { render, staticRenderFns } from "./fcQuestion.vue?vue&type=template&id=694da970"
import script from "./fcQuestion.vue?vue&type=script&lang=js"
export * from "./fcQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports